import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { versions } from '../../../content/docs/config'

interface VersionSwitcherProps {
  currentVersion: string
  currentLang: string
}

function VersionSwitcher({ currentVersion, currentLang }: VersionSwitcherProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const handleVersionChange = (version: string) => {
    navigate(`/docs/${version}/${currentLang}`)
    setIsOpen(false)
  }

  const currentVersionData = versions.find(v => v.version === currentVersion)

  return (
    <div className='version-switcher'>
      <button className='version-switcher-button' onClick={() => setIsOpen(!isOpen)}>
        <span>
          {t('docs.version')}: {currentVersionData?.label || currentVersion}
        </span>
        <span>{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className='version-switcher-dropdown'>
          {versions.map(version => (
            <div
              key={version.version}
              className={`version-switcher-item ${currentVersion === version.version ? 'active' : ''}`}
              onClick={() => handleVersionChange(version.version)}
            >
              <span>{version.label}</span>
              {currentVersion === version.version && <span>✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default VersionSwitcher
